// extracted by mini-css-extract-plugin
export default {"container":"WrongMission_container__1Q1y9","message":"WrongMission_message__B-bXd"};